import { Stack, styled } from '@mui/material';

import LogoIcon from '../../../assets/icons/logo.svg?react';

const AnimatedLogo = styled(LogoIcon)(() => ({
  animation: 'scale 1.5s ease-in-out infinite',
  '@keyframes scale': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.4)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },
}));

export const Loading = () => {
  return (
    <Stack sx={{ margin: 'auto' }}>
      <AnimatedLogo />
    </Stack>
  );
};
